import { withLoading } from '@app/hocs/withLoading.hoc';
import PersonPage from '@app/pages/PersonPage';
import PrinciplePage from '@app/pages/PrinciplePage';
import ResultsPage from '@app/pages/uiComponentsPages/feedback/ResultsPage';
import VoucherPage from '@app/pages/VoucherPage';
import React, { Suspense } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import Require from './Require';
import PackagePage from '@app/pages/PackagePage';

const AuthLayout = React.lazy(() => import('@app/components/layouts/AuthLayout/AuthLayout'));
const AuthLayoutFallback = withLoading(AuthLayout);

const protectedLayout = (
  <Require>
    <Suspense fallback={<div>Loading layout...</div>}>
      <AuthLayoutFallback />
    </Suspense>
  </Require>
);

export const AppRouter: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route element={protectedLayout}>
          <Route path="principle" element={<PrinciplePage />} />
          <Route path="persons" element={<PersonPage />} />
          <Route path="package" element={<PackagePage />} />
          <Route path="/success" element={<ResultsPage />} />
        </Route>
        <Route
          path=""
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <AuthLayoutFallback />
            </Suspense>
          }
        >
          <Route path="" element={<VoucherPage />} />
          <Route path="/*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  );
};
